export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				type: "medium",
				text: "Name of the tutor",
			},
		],
	},
	{
		type: "uni",
		id: 2,
		items: [
			{
				id: 2,
				text: "Overall, the office hours (if offered) are very helpful.",
			},
			{
				id: 3,
				text: "The exercises increased my knowledge on the topic.",
			},
			{
				id: 4,
				text: "I consider the general format of the tutorial to be appropriate (i.e. compulsory attendance, exercise during course, sample solution, modeling calculations).",
			},
			{
				id: 5,
				text: "My tutor has always been well prepared.",
			},
			{
				id: 6,
				text: "My tutor was able to put complicated ideas across.",
			},
			{
				id: 7,
				text: "My tutor was able to impart background knowledge of the content.",
			},
			{
				id: 8,
				text: "My tutor did a good job within the possibilities provided by the lecturer.",
			},
			{
				id: 9,
				text: "The difficulty of the exercises/projects was too high.",
			},
			{
				id: 10,
				text: "The topics have been illustrated during the tutorial by using examples.",
			},
			{
				id: 11,
				text: "During the tutorial a relation between theory and praxis/implementation is developed.",
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 12,
				text: "I especially appreciated:",
			},
			{
				id: 13,
				text: "I did not like:",
			},
			{
				id: 14,
				text: "Suggestions for improvements:",
			},
		],
	},
];
